/**
 * Tooltip
 * Basic tooltip pop-over.
 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withPopper from 'components/hoc/withPopper';

class Tooltip extends React.Component {
  render() {
    const tooltipClass = classNames(
      'tooltip',
      `tooltip--${this.props.placement}`,
    );

    return (
      <div
        className="tooltip-wrapper"
        aria-label={this.props.title}
        ref={this.props.wrapperRef}
      >
        {this.props.children}
        <span
          className={tooltipClass}
          ref={this.props.popperRef}
          style={{
            top: this.props.pos.top,
            left: this.props.pos.left,
          }}
        >
          <span className="tooltip__inner">
            {this.props.title}
          </span>
        </span>
      </div>
    );
  }
}

Tooltip.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
};

export default withPopper(Tooltip);
